import { render, staticRenderFns } from "./AuthEdit.vue?vue&type=template&id=6bc4ed48&scoped=true&"
import script from "./AuthEdit.vue?vue&type=script&lang=js&"
export * from "./AuthEdit.vue?vue&type=script&lang=js&"
import style0 from "./AuthEdit.vue?vue&type=style&index=0&id=6bc4ed48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc4ed48",
  null
  
)

export default component.exports